export interface ICard {
  id: number;
  customer_id: number;
  last_four: number;
  brand: string;
  exp_month: number;
  exp_year: number;
  default: number;
  active: number;
}

export class Card {
  id: number;
  customerId: number;
  lastFour: number;
  brand: string;
  expMonth: number;
  expYear: number;
  isDefault: boolean;
  isActive: boolean;

  constructor(data: ICard) {
    this.id = data.id;
    this.customerId = data.customer_id;
    this.lastFour = data.last_four;
    this.brand = data.brand;
    this.expMonth = data.exp_month;
    this.expYear = data.exp_year;
    this.isDefault = data.default === 1;
    this.isActive = data.active === 1;
  }

  get expirationDate(): string {
    return `${String(this.expMonth).padStart(2, '0')}/${String(this.expYear).slice(-2)}`;
  }

  get maskedNumber(): string {
    return `${String(this.lastFour).padStart(4, '0')}`;
  }
}
